module.exports = "/packs/arrow_forward-5f0229137b4a3900a610e6a79f26ffa9.svg";